var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimatedLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 149",
    style: {
      enableBackground: "new 0 0 306 149"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C20000;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9900;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E30087;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#82CF00;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#26B2FC;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#5E1240;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#dddddd;}\r\n\t.st7{fill:#94A3AB;}\r\n\t* {\r\n              margin: 0;\r\n              padding: 0;\r\n              box-sizing: border-box;\r\n            }\r\n            body {\r\n              text-align: center;\r\n            }\r\n\r\n            #minute-hand {\r\n              animation: hand-rotation 0.5s linear infinite;\r\n              transform-origin: 75.5% 50%;\r\n              transform-box: inherit;\r\n            }\r\n\r\n            #hour-hand {\r\n              animation: hand-rotation 4s linear infinite;\r\n              transform-origin: 75.5% 50%;\r\n            }\r\n\r\n            #RedTail {\r\n              animation: stretch-tail 0.75s ease-in-out infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n            }\r\n\r\n            #OrangeTail {\r\n              animation: stretch-tail 0.8s ease-in infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n              animation-delay: 50ms;\r\n            }\r\n\r\n            #GreenTail {\r\n              animation: stretch-tail 0.7s ease-in infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n              animation-delay: 200ms;\r\n            }\r\n\r\n            #BlueTail {\r\n              animation: stretch-tail 1s ease-in infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n              animation-delay: 100ms;\r\n            }\r\n\r\n            #MagentaTail {\r\n              animation: stretch-tail 0.6s ease-in infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n              animation-delay: 320ms;\r\n            }\r\n\r\n            #PurpleTail {\r\n              animation: stretch-tail 1s ease-in infinite alternate;\r\n              transform-origin: right;\r\n              transform-box: fill-box;\r\n              animation-delay: 160ms;\r\n            }\r\n\r\n            @keyframes hand-rotation {\r\n              from {\r\n                transform: rotateZ(0deg);\r\n              }\r\n              to {\r\n                transform: rotateZ(360deg);\r\n              }\r\n            }\r\n\r\n            @keyframes stretch-tail {\r\n              from {\r\n                transform: scaleX(1);\r\n              }\r\n              to {\r\n                transform: scaleX(0.5);\r\n              }\r\n            }\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-schedge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tails"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RedRoot",
    className: "st0",
    d: "M171.9,0v21.1h1.2c8.9-9.6,20-16.9,32.5-21.1H171.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RedTail"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.4,
    y: 0,
    className: "st0",
    width: 22,
    height: 21.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97,0 97,21.1 173,21.1 173,0  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OrangeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "OrangeRoot",
    className: "st1",
    d: "M169.3,25.5h-14v21.1h2C160.2,39.1,164.2,31.9,169.3,25.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "OrangeTail"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 25.5,
    className: "st1",
    width: 22,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 25.5,
    className: "st1",
    width: 123.1,
    height: 21.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MagentaGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MagentaTail"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "79.2,102.2 79.2,123.4 157,123.4 156.5,102.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6,
    y: 102.2,
    className: "st2",
    width: 22,
    height: 21.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "MagentaRoot",
    className: "st2",
    d: "M156.7,102.2h-1.5l0.5,21.2h13.5C164,117,159.7,109.8,156.7,102.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GreenGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GreenTail"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 51.1,
    className: "st3",
    width: 22,
    height: 21.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.7,
    y: 51.1,
    className: "st3",
    width: 27.3,
    height: 21.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "GreenRoot",
    className: "st3",
    d: "M155.8,51.1h-4.4v21.2h0.9C152.5,65.1,153.6,58,155.8,51.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BlueGroup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BlueTail"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 76.7,
    className: "st4",
    width: 22.1,
    height: 21.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "63,76.7 62.9,97.8 152,97.8 151.7,76.7  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "BlueRoot",
    className: "st4",
    d: "M152.3,76.7h-1.2l0.3,21.2h4.4C153.6,90.9,152.5,83.8,152.3,76.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PurpleGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PurpleRoot",
    className: "st5",
    d: "M173.1,127.8h-0.8V149h33.2C193.1,144.7,182,137.4,173.1,127.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PurpleTail"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 127.8,
    className: "st5",
    width: 22.2,
    height: 21.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 127.8,
    className: "st5",
    width: 26.5,
    height: 21.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "frame",
    className: "st6",
    d: "M299.7,45.9c-5.6-13.6-15.2-25.2-27.4-33.4C260,4.3,245.6,0,230.9,0c-19.8,0-38.7,7.8-52.7,21.8 c-14,14-21.8,32.9-21.8,52.7c0,14.7,4.4,29.1,12.5,41.4c8.2,12.2,19.8,21.8,33.4,27.4c13.6,5.6,28.6,7.1,43,4.2 c14.4-2.9,27.7-10,38.1-20.4c10.4-10.4,17.5-23.7,20.4-38.1C306.8,74.5,305.3,59.6,299.7,45.9z M291.6,71h-6.2v6.8h6.2 c-0.8,14.9-7.2,29-17.7,39.6c-10.6,10.6-24.7,16.9-39.6,17.7V129h-6.8v6.2c-14.9-0.8-29-7.2-39.6-17.7 c-10.6-10.6-16.9-24.7-17.7-39.6h6.2V71h-6.2c0.8-14.9,7.1-29,17.7-39.6c10.6-10.6,24.7-16.9,39.6-17.7v6.2h6.8v-6.2 c14.9,0.8,29,7.2,39.6,17.7C284.5,42,290.8,56.1,291.6,71L291.6,71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "center",
    className: "st7",
    d: "M231.4,80.4c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S228,80.4,231.4,80.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "minute-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MinuteHand",
    className: "st7",
    d: "M236.2,74.3l34-33l-4.9-5l-34,33L236.2,74.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hour-hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HourHand",
    className: "st7",
    d: "M230.8,69l-22-22l-4.9,4.9l22,22L230.8,69z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogoLight);
export default __webpack_public_path__ + "static/media/animated-logo-light.9978d17e.svg";
export { ForwardRef as ReactComponent };